import { useIntegrationPresence } from '@/hooks/useIntegration';
import { Brands } from '@jpi-cloud-web-pro/jpi-cloud-shared/config/brands';
import { brandsList } from '@jpi-cloud-web-pro/jpi-cloud-shared/config/common';
import React, { useMemo } from 'react';
import BrandList from './BrandList';

const isConfigBrand = (brandToCheck, brand) => brandToCheck?.brand?.toLowerCase() === brand;

type ConfigurableBrandListProps = {
  isCompact?: boolean;
};

export const ConfigurableBrandList = ({ isCompact = false }: ConfigurableBrandListProps) => {
  const { showNibeFlowIntegration } = useIntegrationPresence();

  const visibleBrands = useMemo(() => {
    // If integration exists, include all non-hidden brands.
    if (showNibeFlowIntegration) {
      return brandsList.filter(b => !b.hide);
    }
    // Otherwise exclude NIBEF while still hiding marked brands.
    return brandsList.filter(b => !b.hide && b.brand !== Brands.NIBEF);
  }, [showNibeFlowIntegration]);

  return <BrandList brands={visibleBrands} isCompact={isCompact} />;
};
